export type ExploreButtonsProps = {
  class?: string;
  hideArticles?: boolean;
  hideAuthors?: boolean;
  category?: string;
  subcategory?: string;
};

const hrefOf = (path: string, category?: string, subcategory?: string): string => {
  if (!category || category === "all") {
    return path;
  }
  return subcategory && subcategory !== "all" ? `${path}?category=${category}&subcategory=${subcategory}` : `${path}?category=${category}`;
};

const LINK_CLASS = "w-full px-6 py-3 text-white text-base font-semibold rounded-lg transition-all shadow-lg text-center bg-gradient-to-r";

export const ExploreButtons = ({ class: className = "", hideArticles = false, hideAuthors = false, category, subcategory }: ExploreButtonsProps) => (
  <div class={`flex flex-col gap-3 ${className}`}>
    {!hideArticles && (
      <a
        href={hrefOf("/articles", category, subcategory)}
        class={`${LINK_CLASS} from-green-500 to-teal-500 hover:from-green-600 hover:to-teal-600`}
        data-test-click="explore-articles"
        data-test-category={category}
        data-test-subcategory={subcategory}
      >
        Explore Articles
      </a>
    )}
    {!hideAuthors && (
      <a
        href={hrefOf("/authors", category, subcategory)}
        class={`${LINK_CLASS} from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600`}
        data-test-click="explore-authors"
        data-test-category={category}
        data-test-subcategory={subcategory}
      >
        Explore Authors
      </a>
    )}
  </div>
);
